import type { AssetColors } from '../../palette.js';

const MEADOWS = [
  {
    bank: 'M-6.9,-.3 Q-6.1,-2.1 -3.4,-2.7 Q-.8,-2.8 1.1,-1.9 Q3,-1.3 6.7,-.3 Q7.4,.8 5.1,1.2 Q2.5,1.5 -.4,.3 Q-3.8,1.6 -6.9,-.3Z',
    grass:
      'M-6,-.4 -6.2,-2.5 -5.4,-1.2 -4.9,-2.5 -4.5,-.8 M-.7,0 -.8,-2.6 .1,-1.1 .9,-2.8 1.1,-.6 M4.1,.5 4.7,-1.9 4.8,-.1 6.2,-1.1 5.6,.7',
    blooms: [
      [-5, -1, 0.8],
      [-3.2, -1.8, 1],
      [-1.3, -1.1, 0.75],
      [1.5, -0.6, 0.9],
      [3.5, 0, 0.7],
      [5.2, 0.4, 0.72],
    ],
    petals:
      'M0,-2.6 Q-1.7,-2.3 -1.2,-3.6 Q-1.5,-4.7 -.35,-4.35 Q.3,-5.4 .9,-4.2 Q2.1,-4 1.1,-3.1 Q1.2,-2.1 0,-2.6Z',
    centerY: -3.6,
  },
  {
    bank: 'M-5.7,.2 Q-6.1,-1.5 -3.4,-1.8 Q-2,-3.2 .2,-2.5 Q3.4,-3.2 4.8,-1.2 Q6.3,.1 4.5,1 Q2.3,1.4 .1,.8 Q-3.2,1.5 -5.7,.2Z',
    grass:
      'M-5,.2 -5.4,-3.3 -4.4,-1.1 -3.6,-3.5 -3.8,.2 M-.5,.3 -1.1,-4.4 .1,-2 .9,-4.1 1.1,-.2 M3.4,.5 3.2,-2.7 3.9,-1.5 5.2,-2.6 4.4,.8',
    blooms: [
      [-4.1, -0.2, 0.85],
      [-2.1, -0.8, 1.2],
      [0.2, -1.4, 1.3],
      [2.4, -0.6, 1.05],
      [4, 0.4, 0.75],
    ],
    petals:
      'M-.7,-2.8 Q-1.4,-3.4 -.5,-3.6 Q-1.3,-4.3 -.45,-4.5 Q-1,-5.1 -.25,-5.4 L0,-6.3 .35,-5.4 Q1.1,-5 .5,-4.5 Q1.4,-4 .55,-3.6 Q1.4,-3 -.7,-2.8Z',
    centerY: -4.4,
  },
  {
    bank: 'M-6.8,.1 Q-7.4,-1.6 -4.2,-2 Q-2.6,-1.9 -1,-2.7 Q1,-3.3 3,-2.4 Q4.5,-2.8 6.1,-1.5 Q7.8,-.2 5.7,.9 Q3.5,1.6 1.5,.8 Q-1.5,1.9 -3.2,.8 Q-5.4,1.5 -6.8,.1Z',
    grass:
      'M-6,.2 -6.4,-2.4 -5.5,-1.1 -4.5,-2.1 -4.8,.4 M-2.1,.7 -2.9,-2 -1.6,-1 -1,-2.9 -.5,.3 M4.4,.8 4.4,-1.7 5,-.6 6.4,-1.1 5.7,.7',
    blooms: [
      [-5.4, -0.2, 0.75],
      [-3.2, -0.8, 0.95],
      [-0.8, -1.2, 0.85],
      [1.4, -1, 1.1],
      [3.7, -0.8, 0.9],
      [5.4, 0.2, 0.75],
      [0.2, 0.6, 0.7],
    ],
    petals:
      'M-.45,-3.35 Q-1.9,-3.5 -1.5,-4.15 Q-1.1,-4.6 -.45,-4 L-.55,-4.7 Q.1,-5.4 .55,-4.6 L.45,-4 Q1.2,-4.6 1.55,-4 Q1.8,-3.35 .5,-3.35 Q1.25,-2.3 .5,-2.1 Q-.1,-2.1 -.1,-3 Q-.8,-2.1 -1.15,-2.7 Q-1.4,-3.2 -.45,-3.35Z',
    centerY: -3.55,
  },
] as const;

export function svgWildflowerMeadow(x: number, y: number, c: AssetColors, v: number): string {
  const meadow = MEADOWS[v] ?? MEADOWS[0];
  const colors = [c.flower, c.wildflower, c.flowerAlt] as const;
  const flowers = meadow.blooms
    .map(
      ([dx, dy, scale], index) =>
        `<g transform="translate(${dx},${dy}) scale(${scale})">` +
        `<path d="M0,0 Q.2,-1.7 0,${meadow.centerY} M0,-1 Q-1.2,-2.8 -1.2,-1.7 Q-.8,-.9 0,-1 M.1,-1.7 Q1,-3.1 1.2,-2.3 Q.8,-1.4 .1,-1.7" fill="${c.leaf}" stroke="${c.bushDark}" stroke-width=".15"/>` +
        `<path d="${meadow.petals}" fill="${colors[index % colors.length]}"/>` +
        `<ellipse cx="0" cy="${meadow.centerY}" rx=".4" ry=".32" fill="${c.flowerCenter}"/></g>`,
    )
    .join('');
  return (
    `<g transform="translate(${x},${y})">` +
    `<path d="${meadow.bank}" fill="${c.moss}"/>` +
    `<path d="${meadow.grass}" fill="${c.tallGrass}"/>${flowers}` +
    `<path d="M-4.8,.5 -3.4,.1 -2.8,.5 -4,1Z M1.5,.8 2.5,.2 3.9,.65 2.8,1.15Z" fill="${c.leafLight}"/></g>`
  );
}
